import { MessagesScreen } from '~/components/domain/messages/MessagesScreen';

export default function MessagesUnread() {
  return <MessagesScreen initialMessageType="unread" />;
} 